(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["diagnostic-intake"] && !Shopify.designMode) return;
  try {
    class MagstorDiagnosticIntake extends HTMLElement {
 connectedCallback(){
  if(this.bound)return;this.bound=true;
  this.form=this.closest('form');if(!this.form)return;
  this.brand=this.querySelector('[data-brand]');this.paid=this.querySelector('[data-paid]');
  this.support=this.querySelector('[data-support]');this.other=this.querySelector('[data-other-brand]');
  this.brand.addEventListener('change',()=>this.sync());
  this.addEventListener('input',event=>{if(event.target.setCustomValidity)event.target.setCustomValidity('');});
  this.form.addEventListener('submit',event=>{
   if(this.brand.value==='MagStor'){event.preventDefault();event.stopImmediatePropagation();this.support.focus();return;}
   for(const field of this.querySelectorAll('input[required],textarea[required]')){
    field.setCustomValidity(field.disabled||field.value.trim()?'':this.dataset.requiredMessage);
   }
   if(!this.form.reportValidity()){event.preventDefault();event.stopImmediatePropagation();return;}
   if(this.dataset.preview==='true'){
    event.preventDefault();event.stopImmediatePropagation();
    const properties={};for(const [key,value] of new FormData(this.form)){
     const match=key.match(/^properties\[(.*)\]$/);if(match&&String(value).trim())properties[match[1]]=String(value).trim();
    }
    this.dispatchEvent(new CustomEvent('diagnostic-preview-added',{bubbles:true,detail:properties}));
   }
  },true);
  this.sync();
 }
 sync(){
  const magstor=this.brand.value==='MagStor';const other=this.brand.value==='Other';
  this.paid.disabled=magstor;this.paid.hidden=magstor;this.support.hidden=!magstor;
  this.support.tabIndex=-1;this.other.hidden=!other;
  const input=this.other.querySelector('input');input.disabled=!other;input.required=other;input.setCustomValidity('');
  for(const button of this.form.querySelectorAll('button[type="submit"],input[type="submit"]'))button.disabled=magstor;
 }
}
if(!customElements.get('magstor-diagnostic-intake'))customElements.define('magstor-diagnostic-intake',MagstorDiagnosticIntake);
  } catch(e) { console.error(e); }
})();

})();
